import PropTypes from "prop-types";
import { useTheme } from "@mui/material/styles";
import { useSelector } from "react-redux";
import UserSearch from "../dashboard/components/UserSearch";
import useUserSearch from "../dashboard/use-data-hooks/useUserSearch";

UserCourseHistory.propTypes = {
    user: PropTypes.object.isRequired
};

// Replaces the legacy "Journey History" tab with a view of the User Search
// component pre-filtered for the user being viewed (BD-463).
export default function UserCourseHistory(props) {
    const { user } = props;
    const theme = useTheme();
    const { tenancyId } = useSelector((state) => state.tenancy);

    const initialUser = {
        id: user.id,
        name: `${user.firstName || ""} ${user.lastName || ""}`.trim(),
        email: user.email
    };

    const {
        searchQuery,
        anchorEl,
        setAnchorEl,
        filteredUsers,
        isSearching,
        userData,
        userDataLoading,
        selectedUserId,
        handleSearchChange,
        handleSelectUser,
        handleClickAway,
        dateRange,
        setDateRange,
        customStartDate,
        setCustomStartDate,
        customEndDate,
        setCustomEndDate,
        refetchUserData
    } = useUserSearch(tenancyId, initialUser);

    return (
        <UserSearch
            searchQuery={searchQuery}
            setSearchQuery={handleSearchChange}
            anchorEl={anchorEl}
            setAnchorEl={setAnchorEl}
            filteredUsers={filteredUsers}
            isSearching={isSearching}
            handleClickAway={handleClickAway}
            handleSelectUser={handleSelectUser}
            selectedUserId={selectedUserId}
            userData={userData}
            userDataLoading={userDataLoading}
            theme={theme}
            dateRange={dateRange}
            setDateRange={setDateRange}
            customStartDate={customStartDate}
            setCustomStartDate={setCustomStartDate}
            customEndDate={customEndDate}
            setCustomEndDate={setCustomEndDate}
            refetchUserData={refetchUserData}
            lockedToUser={true}
        />
    );
}
